<template>
  <row @click="click" :is="tag" :to="to" :href="href" :target="target" :class="[dense ? 'text-xs' : 'text-sm', disabled ? ['disabled', 'pointer-events-none'] : 'cursor-pointer', baseCss, checked ? `${baseCss}-checked` : '', 'transition-all', 'outline-none', 'duration-500']">
    <cell v-if="multiple" tag="span" x-align="center" :class="[`${baseCss}-icon-wrapper`]">
      <checkbox :icon-color="color" :icon-color-lightness="colorLightness" v-model="checked" :class="['pointer-events-none']" />
    </cell>
    <cell v-if="iconLeft" tag="span" x-align="center" :class="[`${baseCss}-icon-wrapper`]">
      <icon :name="iconLeft" :color="color" :color-lightness="colorLightness" />
    </cell>
    <cell tag="span" :class="[`${baseCss}-label-wrapper` , dense ? 'px-1' : 'px-2']" full-width>
      <div :class="['truncate', 'px-1']" v-html="text" />
    </cell>
    <cell v-if="iconRight" tag="span" x-align="center" :class="[`${baseCss}-icon-wrapper`]">
      <icon :name="iconRight" :color="color" :color-lightness="colorLightness" />
    </cell>
  </row>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'DropdownItem',
  mixins: [
    methods
  ],
  data () {
    return {
      checked: false,
      baseCss: this.componentBaseCss('dropdown-item')
    }
  },
  props: {
    text: {},
    value: {},
    iconLeft: {
      type: String
    },
    dense: {
      type: Boolean
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    },
    iconRight: {
      type: String
    },
    tag: {
      type: String,
      default: 'span'
    },
    to: {
      type: String
    },
    name: {
      type: String
    },
    href: {
      type: String
    },
    target: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click () {
      const $event = {
        value: this.value,
        index: this.index
      }
      if (this.multiple) {
        this.checked = !this.checked
        $event.checked = this.checked
        this.$nextTick(() => {
          this.emit($event)
        })
      } else {
        const refs = this.$parent.$parent.$parent.$parent.$refs['dropdown-item']
        refs.forEach(item => {
          if (item === this) {
            this.checked = true
            this.emit($event)
          } else {
            item.checked = false
          }
        })
        this.$emit('hide')
      }
    },
    emit ($event) {
      this.$emit('input', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/dropdown/dropdown-item.vue